module.exports = __webpack_public_path__ + "static/media/chorthippus_vagans_003_APA.919fe4e5.png";